import React, { useEffect, useRef, useState } from 'react';
import { Modal, Form, Row, Col, Input, Button, Table } from 'antd';
import WariningInfo from '@/components/warning-info';
import apis from '../../../apis';
import FilterTag from '@/components/filter-tag';
import { enhancedFormateTimeStamp } from '@/common/utils/format-time';
import './index.less';
import { goto } from '@/common/utils';
import { RedoOutlined } from '@ant-design/icons';
import IconTip from '@/components/icon-tip';
import env from '@/env';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';

const ListTowerModal = (props) => {
  const [templetList, setTempletList] = useState([]);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState([]);
  const [conditions, setConditions] = useState({
    templetId: undefined,
    towerId: undefined,
    currentPage: 1,
    pageSize: 10,
  });
  const [data, setData] = useState({
    list: [],
    loading: false,
    totalCount: 0,
  });
  useEffect(() => {
    if (!conditions.templetId) return;
    setData({ loading: true });
    apis.channelMicroListTower({ ...conditions }).then((res) => {
      const { ret, data } = res;
      if (ret === '0') {
        setData({ ...data, loading: false });
      }
    });
  }, [conditions]);
  const refresh = (templetId) => {
    setConditions({ templetId, towerId: undefined, currentPage: 1, pageSize: 10 });
  };

  const refreshRef = useRef();
  refreshRef.current = refresh;

  const getTempletList = () => {
    setLoading(true);
    apis.channelMicroListTowerTemplet().then((res) => {
      const {
        ret,
        data: { list = [] },
      } = res;
      setLoading(false);
      if (ret === '0') {
        setTempletList(list);
        setTag([list[0].templateId]);
        if (list.length > 0) {
          refreshRef.current(list[0].templateId);
        }
      }
    });
  };
  const onFinish = (val) => {
    setConditions({ ...conditions, ...val, currentPage: 1, pageSize: 10 });
  };

  useEffect(() => {
    if (!props.visible) return;
    getTempletList();
  }, [props.visible]);

  const columns = [
    {
      align: 'left',
      title: '通天塔项目名称/ID',
      width: 100,
      render: (data) => {
        return (
          <>
            <div>{data.towerName}</div>
            <div>项目ID:{data.towerId}</div>
          </>
        );
      },
    },
    {
      align: 'left',
      title: '页面主标题',
      width: 70,
      dataIndex: 'mainTitle',
    },
    {
      align: 'left',
      title: '页面副标题',
      width: 70,
      dataIndex: 'lessTitle',
    },
    {
      align: 'left',
      title: '关联微频道',
      width: 70,
      dataIndex: 'channelName',
    },
    {
      align: 'left',
      title: '有效时间',
      width: 100,
      render: (data) => {
        return (
          <div>
            {enhancedFormateTimeStamp(data.towerBeginTime, 'YY-MM-DD')}~
            <br />
            {enhancedFormateTimeStamp(data.towerEndTime, 'YY-MM-DD')}
          </div>
        );
      },
    },
    {
      align: 'left',
      title: '创建人ERP',
      width: 70,
      dataIndex: 'erp',
    },
    {
      align: 'left',
      title: '操作',
      width: 160,
      render: (data) => {
        return (
          <div style={{ display: 'flex' }}>
            <a
              style={{ marginRight: '8px' }}
              onClick={() => {
                if (data.related === 1) return;
                props.setTowerInfo(data);
                props.setVisible(false);
              }}
              disabled={data.related === 1}
            >
              关联微频道
            </a>
            <a
              style={{ marginRight: '8px' }}
              onClick={() => {
                goto(data.towerPageLink, true);
              }}
            >
              预览页面
            </a>
            <Link
              style={{ marginRight: '8px' }}
              to={`/batch-micro#/integration/batchcreate?advertGroupId=${data.advertId}&editFlag=1&origin=yx&isMicroChannel=1`}
              target="_blank"
              rel="noopener"
            >
              编辑页面
            </Link>
          </div>
        );
      },
    },
  ];

  return (
    <Modal
      width={1068}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span>关联通天塔项目</span>
          <div
            style={{ color: '#2D64FF', fontSize: '14px', marginLeft: '6px', cursor: 'pointer' }}
            onClick={() => {
              form.resetFields();
              getTempletList();
            }}
          >
            <RedoOutlined />
            刷新
          </div>
          <IconTip title="创建页面后点击刷新即可展示，创建结果需等待10分钟左右。" />
        </div>
      }
      visible={props.visible}
      destroyOnClose
      footer={null}
      onCancel={() => props.setVisible(false)}
    >
      <Spin spinning={loading}>
        <WariningInfo info='微频道仅可关联通过通天塔微频道模版创建的项目，如您未创建，可点击右侧"创建通天塔项目"新建' />
        {templetList.length > 0 && (
          <div style={{ display: 'flex', marginBottom: '16px' }}>
            <div style={{ minWidth: '90px' }}> 页面模版：</div>
            <div style={{ maxHeight: '80px', overflowY: 'scroll', overflowX: 'hidden' }}>
              <FilterTag.Group
                value={tag}
                onChange={(value) => {
                  setConditions({ ...conditions, templetId: value });
                }}
              >
                {templetList.map((item) => {
                  return (
                    <FilterTag value={item.templateId} key={item.templateId}>
                      {item.templateName}
                    </FilterTag>
                  );
                })}
              </FilterTag.Group>
            </div>
          </div>
        )}
        <Form form={form} onFinish={onFinish}>
          <Row gutter={60}>
            <Col span={9}>
              <Form.Item label="通天塔项目ID:" name="towerId">
                <Input placeholder="请输入通天塔项目ID" />
              </Form.Item>
            </Col>

            <Col span={15}>
              <Row align="middle" justify="end">
                <Form.Item>
                  <Button type="primary" htmlType="submit" shape="round" ghost style={{ marginRight: '16px' }}>
                    查询
                  </Button>
                </Form.Item>
                <Form.Item>
                  <Button onClick={() => form.resetFields()} type="submit" shape="round">
                    重置
                  </Button>
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
          <div className="list-tower-modal-title">可关联通天塔项目</div>
          <Button
            type="primary"
            shape="round"
            onClick={() =>
              window.open(
                '/batch-micro#/integration/batchcreate?isMicroChannel=1&origin=yx&singlePageLimit=1',
                '_blank',
                'noopener'
              )
            }
          >
            创建通天塔页面
          </Button>
        </div>
        <Table
          rowKey="towerId"
          scroll={{ y: 340 }}
          columns={columns}
          loading={data.loading}
          dataSource={data.list}
          pagination={{
            showSizeChanger: false,
            current: conditions.currentPage,
            total: data.totalCount,
            pageSize: conditions.pageSize,
            onChange: (toPage, pageSize) => {
              setConditions({
                ...conditions,
                currentPage: toPage,
                pageSize: pageSize,
              });
            },
          }}
        />
      </Spin>
    </Modal>
  );
};
export default ListTowerModal;
